import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { observer } from 'mobx-react'
import DashboardCustomers from '../DashboardCustomers'
import DashboardStats from './DashboardStats'
import DashboardTodo from './partials/DashboardTodo'
import Select from '../common/select'
import GroupedBar from '../charts/GroupedBar'
import VerticalBar from '../charts/VerticalBar'
import { setActiveCustomer, setActiveUser } from '../../services/customersService'
import DashStore from './Store/DashStore'

@observer
class Dashboard extends Component {
    constructor(props) {
        super(props)

        let { users } = this.props
        
        users.unshift({ _id: 0, name: 'Alla' })

        this.state = {
            category: window.dashboard.data.lastDisplayedCustomerCategory,
            filterOnUserId: this.props.user.id,
            users: users,
            selectedCustomer: 0
        }
    }
    componentDidMount() {
        const displayCustomer = window.dashboard.data.lastDisplayedCustomer ? window.dashboard.data.lastDisplayedCustomer : window.dashboard.data.customers[0]
        this.customerChanged(displayCustomer)
    }
    customerChanged(customer) {
        setActiveCustomer(customer.id)
        this.setState({ customer })
    }
    onUserSelect(filterOnUserId) {
        setActiveUser(filterOnUserId);
        this.setState({ filterOnUserId });

        DashStore.loadDash(filterOnUserId)
    }
    onHandleCustomerSelect(selectedCustomer) {
        this.setState({ selectedCustomer })
    }
    render() {
        const { category, customer, users, filterOnUserId } = this.state

        return <div className="dashboard">
                <div className="dashboard__row dashboard__row--right">
                    <div className="dashboard__col dashboard__col--w-full">
                        <Select
                            name="user_id"
                            hideBlankItem={ true }
                            onChange={ event => this.onUserSelect(event.target.value) }
                            options={users}
                            value={filterOnUserId}
                        />                    
                    </div>
                </div>

                <div className="dashboard__row">
                    <div className="dashboard__row__col dashboard__row__col--blue">
                        <DashboardCustomers
                            filterOnUserId={ filterOnUserId }
                            customers={ window.dashboard.data.customers }
                            category={ category }
                            categories={ window.dashboard.data.categories }
                            onHandleCustomerSelect={customer => this.customerChanged(customer) }
                        />
                    </div>
                    <div className="dashboard__row__col">
                        <div className="dashboard-reservation">
                            <h3 className="dashboard-reservation__title">Beläggning i timmar</h3>

                            <GroupedBar chartOpt={ DashStore.reservationChart } />
                        </div>

                        <div className="dashboard-overview">
                            <h3 className="dashboard-overview__title">Överblick</h3>

                            <div className="dashboard-overview__row">
                                <h4 className="dashboard-overview__row__title">Orderstock</h4>
                                <ul className="dashboard-overview__row__list">
                                    <li className="dashboard-overview__row__list__item">Vecka</li>
                                    <li className="dashboard-overview__row__list__item">{ `${DashStore.overview.order.week.quantity} st`}</li>
                                    <li className="dashboard-overview__row__list__item">{ `${DashStore.overview.order.week.amount} tkr`}</li>
                                    <li className="dashboard-overview__row__list__item" title="Tim:min">{ `${DashStore.overview.order.week.time} h`}</li>
                                </ul>
                                <ul className="dashboard-overview__row__list">
                                    <li className="dashboard-overview__row__list__item">Månad</li>
                                    <li className="dashboard-overview__row__list__item">{ `${DashStore.overview.order.month.quantity} st`}</li>
                                    <li className="dashboard-overview__row__list__item">{ `${DashStore.overview.order.month.amount} tkr`}</li>
                                    <li className="dashboard-overview__row__list__item" title="Tim:min">{ `${DashStore.overview.order.month.time} h`}</li>
                                </ul>
                                <ul className="dashboard-overview__row__list">
                                    <li className="dashboard-overview__row__list__item">År</li>
                                    <li className="dashboard-overview__row__list__item">{ `${DashStore.overview.order.year.quantity} st`}</li>
                                    <li className="dashboard-overview__row__list__item">{ `${DashStore.overview.order.year.amount} tkr`}</li>
                                    <li className="dashboard-overview__row__list__item" title="Tim:min">{ `${DashStore.overview.order.year.time} h`}</li>
                                </ul>
                            </div>

                            <div className="dashboard-overview__row">
                                <h4 className="dashboard-overview__row__title">Levererat</h4>
                                <ul className="dashboard-overview__row__list">
                                    <li className="dashboard-overview__row__list__item">Vecka</li>
                                    <li className="dashboard-overview__row__list__item">{ `${DashStore.overview.delivery.week.quantity} st`}</li>
                                    <li className="dashboard-overview__row__list__item">{ `${DashStore.overview.delivery.week.amount} tkr`}</li>
                                    <li className="dashboard-overview__row__list__item" title="Tim:min">{ `${DashStore.overview.delivery.week.time} h`}</li>
                                </ul>
                                <ul className="dashboard-overview__row__list">
                                    <li className="dashboard-overview__row__list__item">Månad</li>
                                    <li className="dashboard-overview__row__list__item">{ `${DashStore.overview.delivery.month.quantity} st`}</li>
                                    <li className="dashboard-overview__row__list__item">{ `${DashStore.overview.delivery.month.amount} tkr`}</li>
                                    <li className="dashboard-overview__row__list__item" title="Tim:min">{ `${DashStore.overview.delivery.month.time} h`}</li>
                                </ul>
                                <ul className="dashboard-overview__row__list">
                                    <li className="dashboard-overview__row__list__item">År</li>
                                    <li className="dashboard-overview__row__list__item">{ `${DashStore.overview.delivery.year.quantity} st`}</li>
                                    <li className="dashboard-overview__row__list__item">{ `${DashStore.overview.delivery.year.amount} tkr`}</li>
                                    <li className="dashboard-overview__row__list__item">{ `${DashStore.overview.delivery.year.time} h`}</li>
                                </ul>
                            </div>

                            <div className="dashboard-overview__row">
                                <ul className="dashboard-overview__row__list">
                                    <li className="dashboard-overview__row__list__item"><a href="/cost-estimates?status=tenderAccepted&amp;user_id=0">Obekräftade ordrar</a></li>
                                    <li className="dashboard-overview__row__list__item"><a href="/cost-estimates?status=tenderAccepted&amp;user_id=0">{ `${DashStore.overview.unconfirmed} st`}</a></li>
                                </ul>
                            </div>                         
                        </div>

                        <div className="dashboard-delivered">
                            <h3 className="dashboard-delivered__title">Levererat tkr</h3>

                            <VerticalBar chartOpt={ DashStore.deliveredChart } valuesAsKSEK={true}/>
                        </div>
                    </div>
                    <div className="dashboard__row__col">
                        <DashboardStats filterOnUserId={ filterOnUserId } />

                        <div className="dashboard-todo">
                            <DashboardTodo filterOnUserId={ filterOnUserId } />
                        </div>
                    </div>
                </div>
            </div>

            // <Fragment>
            //     <div className="row">
            //         <div className="col-sm-4 col-lg-2 col-mb-4 ml-auto text-right">
            //             <Select
            //                 name="user_id"
            //                 hideBlankItem={true}
            //                 onChange={event => {
            //                     const val = event.target.value;
            //                     this.onUserSelect(val);
            //                 }}
            //                 options={users}
            //                 value={filterOnUserId}
            //             />
            //         </div>
            //     </div>
            //     <div className="row">
            //         <div className="col-4 pr-2">
            //             <div className="col-12 col-blue2-bg">
            //                 <DashboardCustomer
            //                     customers={window.dashboard.data.customers}
            //                     customer={customer}
            //                     onCustomerChanged={customer => {
            //                         this.customerChanged(customer);
            //                     }}
            //                 />
            //             </div>
            //         </div>
            //         <div className="col-4 pl-2 pr-2">
            //             <div className="col-12 col-blue2-bg">
            //                 <DashboardCustomers
            //                     filterOnUserId={filterOnUserId}
            //                     customers={window.dashboard.data.customers}
            //                     category={category}
            //                     categories={window.dashboard.data.categories}
            //                     onHandleCustomerSelect={customer => {
            //                         this.customerChanged(customer);
            //                     }}
            //                 />
            //             </div>
            //         </div>
            //         <div className="col-4 pl-2">
            //             <div className="col-12 col-blue2-bg">
            //                 <DashboardStats filterOnUserId={filterOnUserId} />
            //             </div>
            //             <div className="col-12 col-blue2-bg mt-3">
            //                 <DashboardTodo filterOnUserId={filterOnUserId} />
            //             </div>
            //         </div>
            //     </div>
            // </Fragment >
    }
}

if (window.dashboard) {
    ReactDOM.render(
        <Dashboard
            user={ window.dashboard.data.lastDisplayedUser }
            users={ window.dashboard.data.users }
            lastDisplayedCustomer={ window.dashboard.lastDisplayedCustomer }
            lastDisplayedContactCategoryId={ window.dashboard.lastDisplayedContactCategoryId }
        />,
        window.dashboard.settings.target
    )
}
